function getDescriptionByUserLanguage(record) {
    let userPreference = localStorage.getItem("userPreference")

    if (userPreference) {
        let userPreferenceJSON = JSON.parse(userPreference);
        let language = userPreferenceJSON.language;

        if (language) {

            if (language == "es" && record.descriptionEs) {
                return record.descriptionEs
            }
            else if (language == "ar" && record.descriptionAr) {
                return record.descriptionAr
            }
            else if (language == "fr" && record.descriptionFr) {
                return record.descriptionFr
            }
            else if (language == "zh" && record.descriptionZh) {
                return record.descriptionZh
            }
            else if (language == "pt" && record.descriptionPt) {
                return record.descriptionPt
            }
            else if (language == "ru" && record.descriptionRu) {
                return record.descriptionRu
            }
            else if (language == "hi" && record.descriptionHi) {
                return record.descriptionHi
            }
            else if (language == "nl" && record.descriptionNl) {
                return record.descriptionNl
            }
            else {
                return record.descriptionEn
            }

        }
    }
    return record.descriptionEn;
}

function getCodeDescriptionByUserLanguage(record) {
    let userPreference = localStorage.getItem("userPreference")
    if (userPreference) {
        let userPreferenceJSON = JSON.parse(userPreference);
        let language = userPreferenceJSON.language;

        if (language) {

            if (language == "es" && record.descriptionEs) {
                return `${record.code};${record.descriptionEs}`
            }
            else if (language == "ar" && record.descriptionAr) {
                return `${record.code};${record.descriptionAr}`
            }
            else if (language == "fr" && record.descriptionFr) {
                return `${record.code};${record.descriptionFr}`
            }
            else if (language == "zh" && record.descriptionZh) {
                return `${record.code};${record.descriptionZh}`
            }
            else if (language == "pt" && record.descriptionPt) {
                return `${record.code};${record.descriptionPt}`
            }
            else if (language == "ru" && record.descriptionRu) {
                return `${record.code};${record.descriptionRu}`
            }
            else if (language == "hi" && record.descriptionHi) {
                return `${record.code};${record.descriptionHi}`
            }
            else if (language == "nl" && record.descriptionNl) {
                return `${record.code};${record.descriptionNl}`
            }
            else {
                return `${record.code};${record.descriptionEn}`
            }
        }
    }
    return `${record.code};${record.descriptionEn}`
}

function getIntlCodeDescriptionByUserLanguage(record) {
    let userPreference = localStorage.getItem("userPreference")
    if (userPreference) {
        let userPreferenceJSON = JSON.parse(userPreference);
        let language = userPreferenceJSON.language;

        if (language) {

            if (language == "es" && record.descriptionEs) {
                return `${record.intlcode};${record.descriptionEs}`
            }
            else if (language == "ar" && record.descriptionAr) {
                return `${record.intlcode};${record.descriptionAr}`
            }
            else if (language == "fr" && record.descriptionFr) {
                return `${record.intlcode};${record.descriptionFr}`
            }
            else if (language == "zh" && record.descriptionZh) {
                return `${record.intlcode};${record.descriptionZh}`
            }
            else if (language == "pt" && record.descriptionPt) {
                return `${record.intlcode};${record.descriptionPt}`
            }
            else if (language == "ru" && record.descriptionRu) {
                return `${record.intlcode};${record.descriptionRu}`
            }
            else if (language == "hi" && record.descriptionHi) {
                return `${record.intlcode};${record.descriptionHi}`
            }
            else if (language == "nl" && record.descriptionNl) {
                return `${record.intlcode};${record.descriptionNl}`
            }
            else if (language == "en" && record.descriptionEn) {
                return `${record.intlcode};${record.descriptionEn}`
            } 
        }
    }
    return `${record.intlcode};${record.descriptionEn}`
}

function getIntlCodeCodeDescriptionByUserLanguage(record) {
    let userPreference = localStorage.getItem("userPreference")
    if (userPreference) {
        let userPreferenceJSON = JSON.parse(userPreference);
        let language = userPreferenceJSON.language;

        if (language) {

            if (language == "es" && record.descriptionEs) {
                return `${record.intlcode};${record.code};${record.descriptionEs}`
            }
            else if (language == "ar" && record.descriptionAr) {
                return `${record.intlcode};${record.code};${record.descriptionAr}`
            }
            else if (language == "fr" && record.descriptionFr) {
                return `${record.intlcode};${record.code};${record.descriptionFr}`
            }
            else if (language == "zh" && record.descriptionZh) {
                return `${record.intlcode};${record.code};${record.descriptionZh}`
            }
            else if (language == "pt" && record.descriptionPt) {
                return `${record.intlcode};${record.code};${record.descriptionPt}`
            }
            else if (language == "ru" && record.descriptionRu) {
                return `${record.intlcode};${record.code};${record.descriptionRu}`
            }
            else if (language == "hi" && record.descriptionHi) {
                return `${record.intlcode};${record.code};${record.descriptionHi}`
            }
            else if (language == "nl" && record.descriptionNl) {
                return `${record.intlcode};${record.code};${record.descriptionNl}`
            }
            else {
                return `${record.intlcode};${record.code};${record.descriptionEn}`
            }
        }
    }
    return `${record.intlcode};${record.code};${record.descriptionEn}`
}

function getCodeIntlCodeDescriptionByUserLanguage(record) {
    let userPreference = localStorage.getItem("userPreference")
    if (userPreference) {
        let userPreferenceJSON = JSON.parse(userPreference);
        let language = userPreferenceJSON.language;

        if (language) {

            if (language == "es" && record.descriptionEs) {
                return `${record.code};${record.intlcode};${record.descriptionEs}`
            }
            else if (language == "ar" && record.descriptionAr) {
                return `${record.code};${record.intlcode};${record.descriptionAr}`
            }
            else if (language == "fr" && record.descriptionFr) {
                return `${record.code};${record.intlcode};${record.descriptionFr}`
            }
            else if (language == "zh" && record.descriptionZh) {
                return `${record.code};${record.intlcode};${record.descriptionZh}`
            }
            else if (language == "pt" && record.descriptionPt) {
                return `${record.code};${record.intlcode};${record.descriptionPt}`
            }
            else if (language == "ru" && record.descriptionRu) {
                return `${record.code};${record.intlcode};${record.descriptionRu}`
            }
            else if (language == "hi" && record.descriptionHi) {
                return `${record.code};${record.intlcode};${record.descriptionHi}`
            }
            else if (language == "nl" && record.descriptionNl) {
                return `${record.code};${record.intlcode};${record.descriptionNl}`
            }
            else {
                return `${record.code};${record.intlcode};${record.descriptionEn}`
            }
        }
    }
    return `${record.code};${record.intlcode};${record.descriptionEn}`
}

export {getDescriptionByUserLanguage, getCodeDescriptionByUserLanguage, getIntlCodeDescriptionByUserLanguage, getIntlCodeCodeDescriptionByUserLanguage,getCodeIntlCodeDescriptionByUserLanguage}